import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurableMessage } from '@shared/models/referentiel/configurable-message';
import { Observable } from 'rxjs';
import { ConfigurableMessageConfig } from '../config/configurable-message.config';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
    providedIn: 'root',
})
export class ConfigurableMessageService {
    constructor(private http: HttpClient) { }

    getAllActifConfigurableMessages(): Observable<ConfigurableMessage[]> {
        return this.http.get<ConfigurableMessage[]>(ConfigurableMessageConfig.configurableMessageList(AppSourceEnum.POF));
    }
}
